import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { articles } from '@/mocks/articles';

const relatedArticles = [
  { id: 'litbuy-spreadsheet-tips', title: 'LitBuy Spreadsheet Tips and Tricks' },
  { id: 'how-to-use-litbuy-spreadsheet', title: 'How to Use a LitBuy Spreadsheet Effectively' },
  { id: 'litbuy-spreadsheet-workflow', title: 'LitBuy Spreadsheet Workflow Guide' },
];

export default function MistakesPage() {
  return (
    <main>
      <Navbar />
      <ArticleLayout article={articles['litbuy-spreadsheet-mistakes']} relatedArticles={relatedArticles} />
      <Footer />
    </main>
  );
}